import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import JoinForm from '../JoinForm/JoinForm';
import JoinText from '../JoinText/JoinText';
import './Join.css';

const Join = () => (
  <div className="Join">
    <div className="Join__title">
      <SectionTitle>
        Nous
        <strong className="SectionTitle__item--bold">&nbsp;rejoindre</strong>
      </SectionTitle>
    </div>
    <div className="Join__container">
      <JoinForm classname="Join__JoinForm" />
      <JoinText classname="Join__JoinText" />
    </div>
  </div>
);

export default Join;
